<template>
  <div>
    <grid id="gatewayVersionsHistoryGrid"
          :title="$t('gc-software:versionsHistory')"
          :columns="columns"
          :paginated-dto="history"
          :pagination="false"
          :download-btn="false"
          @load="getHistory"
    >
      <template slot="compare" slot-scope="props">
        <input :id="'history-' + props.dto.fromDate"
               v-model="selectedHistories"
               :value="props.dto"
               type="checkbox"
        >
        <label :for="'history-' + props.dto.fromDate" />
      </template>

      <template slot="fromDate" slot-scope="props">{{ props.dto.fromDate | date }}</template>
      <template slot="toDate" slot-scope="props">{{ props.dto.toDate | date }}</template>

      <a slot="details" slot-scope="props" :title="$t('gc-software:displayDetails') | capitalize" href @click.prevent="displayDetailsModal(props.dto)">
        {{ displayDetails(props.dto) | stringify | substring(100) }}
      </a>
    </grid>

    <button v-if="selectedHistories.length >= 2" id="compareButton" class="btn btn-primary mt-3" @click.prevent="displayComparisonModal">{{ $t('gc-software:compareSelectedVersions') }}</button>

    <modal id="detailsModal"
           v-model="showDetailsModal"
           :title="$t('gc-software:versionDetails')"
    >
      <table slot="modal-body" class="table table-sm table-borderless">
        <thead>
          <tr>
            <th>
              {{ $t('gc-software:from') | capitalize }} {{ detailsDto.fromDate | date }}<br>
              {{ $t('gc-software:to') | capitalize }} {{ detailsDto.toDate | date }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(version, versionIndex) in detailsDto.versions" :key="versionIndex">
            <td>{{ version.description }}</td>
          </tr>
        </tbody>
      </table>
    </modal>

    <modal id="comparisonModal"
           v-model="showComparisonModal"
           :title="$t('gc-software:selectedVersionsDetails')"
           size="lg"
    >
      <table slot="modal-body" class="table table-sm table-borderless">
        <thead>
          <tr>
            <th v-for="(selectedHistory, indexVersion) in selectedHistoriesSortedAsc" :key="indexVersion">
              {{ $t('gc-software:from') | capitalize }} {{ selectedHistory.fromDate | date }}<br>
              {{ $t('gc-software:to') | capitalize }} {{ selectedHistory.toDate | date }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="versionIndex in versionsSelectedNbIndexes" :key="versionIndex">
            <td v-for="(selectedHistory, historyIndex) in selectedHistoriesSortedAsc" :key="historyIndex">
              {{ selectedHistory['versions'][versionIndex - 1] ? selectedHistory['versions'][versionIndex - 1]['description'] : '' }}
            </td>
          </tr>
        </tbody>
      </table>
    </modal>
  </div>
</template>

<script>
import { orderBy, max, map, isEmpty, each, reduce } from 'lodash-es'
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'
import subMonths from 'date-fns/sub_months'
import getTime from 'date-fns/get_time'

export default {
  props: {
    eui: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      history: {},
      // Details modal
      showDetailsModal: false,
      detailsDto: [],
      // Comparison
      selectedHistories: [],
      showComparisonModal: false
    }
  },

  computed: {
    ...mapGetters(['gateway']),

    columns () {
      return [
        { text: this.$t('gc-software:compare'), slot: 'compare', class: 'text-center' },
        { text: this.$t('gc-software:fromDate'), slot: 'fromDate' },
        { text: this.$t('gc-software:toDate'), slot: 'toDate' },
        { text: this.$t('gc-software:details'), slot: 'details' }
      ]
    },

    selectedHistoriesSortedAsc () {
      return orderBy(this.selectedHistories, ['fromDate', 'toDate'], ['asc', 'asc'])
    },

    versionsSelectedNbIndexes () {
      return max(map(this.selectedHistories, selectedHistory => selectedHistory.versions.length))
    }
  },

  watch: {
    eui () {
      // Reset data, and get data from new gateway
      this.history = {}
    },

    gateway () {
      // Do not refresh is we olready have the data
      if (!isEmpty(this.history)) return

      this.getHistory()
    }
  },

  created () {
    this.getHistory()
  },

  methods: {
    async getHistory () {
      if (isEmpty(this.gateway)) return

      const params = { startDate: getTime(subMonths(new Date(), 1)), endDate: Date.now() }
      let error, response
      [error, response] = await to(this.$api.getGatewayVersions(this.gateway, params))
      if (error || !response) return

      // Order version keys by index
      each(response.data.list, version => {
        version.versions = orderBy(version.versions, ['index'])
      })
      this.history = response.data
      // Order list by date
      this.history.list = orderBy(this.history.list, ['fromDate', 'toDate'], ['desc', 'desc'])
    },

    displayDetails (versionDto) {
      return reduce(versionDto.versions, (versionStr, version) => {
        return versionStr !== '' ? `${versionStr}, ${version.description}` : version.description
      }, '')
    },

    displayDetailsModal (versionDto) {
      this.detailsDto = versionDto
      this.showDetailsModal = true
    },

    displayComparisonModal () {
      this.showComparisonModal = true
    }
  }
}
</script>
